import React, { Component, Suspense } from 'react'
import { Navigate, HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import PrivateRoute from './router/PrivateRoute'
import { LoadScript } from '@react-google-maps/api'
import { constant } from './constant/constant'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <LoadScript googleMapsApiKey={constant.MAP_API_KEY}>
            <Routes>
              <Route path="/" element={<Navigate replace to="/login" />} />
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route path="page404" component={<Page404 />} />
              <Route exact path="/" element={<PrivateRoute />}>
                <Route path="*" name="Home" element={<DefaultLayout />} />
              </Route>

              <Route path="*" component={<Page404 />} />
            </Routes>
          </LoadScript>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
